import React from 'react';
import { Bot } from 'lucide-react';
import { AGENT_LABELS } from '../mock';

// Attribution chip: marks content as agent-generated. agent = key or free label.
export default function AgentChip({ agent = 'verification', label, size = 'sm' }) {
  const name = label || AGENT_LABELS[agent] || agent;
  const pad = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-[11px]';
  return (
    <span className={`inline-flex items-center gap-1 rounded-md bg-violet-50 text-violet-700 border border-violet-200 font-medium ${pad}`}>
      <Bot className="h-3 w-3" />
      {name} Agent
    </span>
  );
}
